import React, { useMemo } from 'react';
import cx from 'classnames';
import { format, lastDayOfMonth } from 'date-fns';
import { Text } from '../../../ui-kit';
import InternalCreditsSummary from './components/InternalCreditsSummary';

















const today = new Date();
const currentMonth = format(today, 'MMM dd');
const lastDateOfMonth = format(lastDayOfMonth(today), 'MMM dd');

export default function DetailedViewSection({
  usedCredits,
  workspaceRecurringBalance,
  workspaceTopUpCredits,
  wsBufferLimit,
  workspaceBufferCreditsRemaining,
  teamHasBufferEnabled,
  selectedBucket,
  allTeamsBalances,
  teamBufferLimit,
  isInternalMode = false,
  workspaceThisMonthOnlyBalance,
  hideBufferOwed,
  workspaceThisMonthOnly
}) {
  const bufferOwed = wsBufferLimit - workspaceBufferCreditsRemaining;
  const { usageOfThisMonthOnlyCredits, usageOfWorkspaceCredits, usageOfTopUpCredits } = usedCredits;
  const {
    credit,
    thisMonthOnlyBalance,
    thisMonthOnlyRecurringBalance,
    topUpCredit
  } = selectedBucket;

  const originalRecurringMonthly = Number(credit) -
  Number(thisMonthOnlyBalance) -
  Number(thisMonthOnlyRecurringBalance);

  const originalThisMonthOnly = Number(thisMonthOnlyBalance) +
  Number(thisMonthOnlyRecurringBalance);

  const originalTopUp = Number(topUpCredit);
  const selectedTeamId = selectedBucket.teamId;


  const { workspaceRecurringDelta, workspaceThisMonthOnlyDelta } = useMemo(() => {
    if (usageOfThisMonthOnlyCredits > 0 &&
    usageOfThisMonthOnlyCredits > workspaceThisMonthOnlyBalance)
    {
      return {
        workspaceRecurringDelta: usageOfThisMonthOnlyCredits - workspaceThisMonthOnlyBalance +
        usageOfWorkspaceCredits,
        workspaceThisMonthOnlyDelta: workspaceThisMonthOnlyBalance
      };
    }

    const totalThisMonthOnly = Math.abs(usageOfThisMonthOnlyCredits) +
    workspaceThisMonthOnlyBalance;

    if (usageOfThisMonthOnlyCredits < 0 && totalThisMonthOnly > workspaceThisMonthOnly) {
      return {
        workspaceRecurringDelta: workspaceThisMonthOnly -
        totalThisMonthOnly +
        usageOfWorkspaceCredits,
        workspaceThisMonthOnlyDelta: -workspaceThisMonthOnly
      };
    }

    return {
      workspaceRecurringDelta: usageOfWorkspaceCredits,
      workspaceThisMonthOnlyDelta: usageOfThisMonthOnlyCredits
    };
  }, [
  usageOfThisMonthOnlyCredits,
  usageOfWorkspaceCredits,
  workspaceThisMonthOnlyBalance,
  workspaceThisMonthOnly]
  );

  const workspaceMonthDelta = Number(workspaceRecurringDelta) + Number(workspaceThisMonthOnlyDelta);
  const workspaceMonthBalance = Number(workspaceRecurringBalance) +
  Number(workspaceThisMonthOnlyBalance);

  const teamMonthDelta = Number(usageOfWorkspaceCredits) + Number(usageOfThisMonthOnlyCredits);
  const teamMonthBalance = Number(originalRecurringMonthly) + Number(originalThisMonthOnly);

  if (isInternalMode) {
    return (
      <InternalCreditsSummary
        usedCredits={usedCredits}
        selectedTeamId={selectedTeamId}
        allTeamsBalances={allTeamsBalances}
        workspaceThisMonthOnly={workspaceThisMonthOnly}
        // Team
        originalTopUp={originalTopUp}
        originalRecurringMonthly={originalRecurringMonthly}
        originalThisMonthOnly={originalThisMonthOnly}
        // Workspace
        workspaceTopUpCredits={workspaceTopUpCredits}
        workspaceThisMonthOnlyBalance={workspaceThisMonthOnlyBalance}
        workspaceRecurringBalance={workspaceRecurringBalance}
        // Buffer
        bufferOwed={bufferOwed}
        wsBufferLimit={wsBufferLimit}
        workspaceThisMonthOnlyDelta={workspaceThisMonthOnlyDelta}
        workspaceRecurringDelta={workspaceRecurringDelta} />);


  }

  return (
    <div className="detailed-view">
      <Text heading5 className="adjust-credits__period">
        {`Current Month - ${currentMonth} to ${lastDateOfMonth}`}
      </Text>
      <div className="detailed-view__container">
        <div className="detailed-view__block detailed-view__container--block">
          <Text heading5>Workspace</Text>
          <div className="detailed-view__block__item">
            <Text noMargin>Month</Text>
            <Text heading5 noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': workspaceMonthDelta <= 0,
                  'detailed-view__block__item__subtracted-credits': workspaceMonthDelta > 0
                })}
                data-testid="workspace-recurring-change">

                {workspaceMonthDelta !== 0 &&
                workspaceMonthDelta !== Infinity &&
                selectedTeamId &&
                `(${workspaceMonthDelta < 0 ? '+' : '-'}${Math.abs(workspaceMonthDelta)})`}

              </span>
              <span data-testid="workspace-recurring-balance">
                {`${workspaceMonthBalance} Credits`}
              </span>
            </Text>
          </div>
          <div className={`detailed-view__block__item ${teamHasBufferEnabled || 'extra-bottom-padding'}`}>
            <Text noMargin>Flex</Text>
            <Text noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': usageOfTopUpCredits <= 0,
                  'detailed-view__block__item__subtracted-credits': usageOfTopUpCredits > 0
                })}>

                {usageOfTopUpCredits !== 0 &&
                !selectedTeamId &&
                `(${usageOfTopUpCredits < 0 ? '+' : '-'}${Math.abs(usageOfTopUpCredits)})`}

                {usageOfTopUpCredits !== 0 &&
                selectedTeamId &&
                `(${usageOfTopUpCredits > 0 ? '-' : '+'}${Math.abs(usageOfTopUpCredits)})`}

              </span>
              {`${workspaceTopUpCredits} Credits`}
            </Text>
          </div>

          {teamHasBufferEnabled && !hideBufferOwed &&
          <div className="detailed-view__block__item">
              <Text heading4>Credit Advance Owed</Text>
              <Text heading4>
                {`
                  ${
              selectedBucket.bufferRemaining >= 0 ?
              teamBufferLimit - selectedBucket.bufferRemaining :
              0
              } of ${teamBufferLimit} Credits
                `}
              </Text>
            </div>}

        </div>

        <div className="detailed-view__block detailed-view__container--block">
          <Text heading5>{`Team - ${selectedBucket.label}`}</Text>
          <div className="detailed-view__block__item">
            <Text noMargin>Month</Text>
            <Text noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': teamMonthDelta > 0,
                  'detailed-view__block__item__subtracted-credits': teamMonthDelta <= 0
                })}>

                {teamMonthDelta !== 0 ?
                `(${teamMonthDelta > 0 ? '+' : '-'}${Math.abs(teamMonthDelta)})` :
                null}

              </span>
              {`${teamMonthBalance} Credits`}
            </Text>
          </div>
          <div className="detailed-view__block__item">
            <Text noMargin>Flex</Text>
            <Text noMargin>
              <span
                className={cx({
                  'detailed-view__block__item__added-credits': usageOfTopUpCredits > 0,
                  'detailed-view__block__item__subtracted-credits': usageOfTopUpCredits <= 0
                })}>

                {usageOfTopUpCredits !== 0 &&
                selectedTeamId &&
                `(${usageOfTopUpCredits < 0 ? '-' : '+'}${Math.abs(usageOfTopUpCredits)})`}

              </span>
              {`${originalTopUp} Credits`}
            </Text>
          </div>
        </div>
      </div>
    </div>);

}